import { useEffect, useState } from 'react';

import { useApolloContext } from '~/campaign/core/context/ApolloContext';
import { useSizeContext } from '~/utilities/context/dynamic/SizeContext';
import { useAppContext } from '~/utilities/context/static/AppContext';
import { usePDPContext } from '~/utilities/context/static/PDPContext';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import type { Product } from '~/utilities/graphql/codegen';
import { fetchProduct } from '~/utilities/graphql/queries';

type Params = {
  setHasLocalStoreStock: (value: boolean) => void;
};

export const useProductFetch = ({ setHasLocalStoreStock }: Params) => {
  const { client: apolloClient } = useApolloContext();
  const {
    configuration: { enablePdpLocalStoreStockSizeAvailability },
  } = useStaticContext();
  const { locale, siteType } = useAppContext();
  const { product } = usePDPContext();
  const { sizeCode } = useSizeContext();

  const [currentSizeVariantProduct, setCurrentSizeVariantProduct] = useState<Product>(product);

  useEffect(() => {
    if (!enablePdpLocalStoreStockSizeAvailability || !sizeCode) {
      return;
    }

    const fetchData = async () => {
      try {
        const { product } = await fetchProduct({
          siteType,
          code: sizeCode,
          locale,
          apolloClient,
        });

        setCurrentSizeVariantProduct(product);
        setHasLocalStoreStock(product.hasLocalStoreStock ?? false);
      } catch (error) {
        console.error('Fetch Product Error :: ', error);
      }
    };

    fetchData();
  }, [
    enablePdpLocalStoreStockSizeAvailability,
    sizeCode,
    setHasLocalStoreStock,
    locale,
    siteType,
    apolloClient,
  ]);

  return {
    currentSizeVariantProduct,
  };
};
